import { render, staticRenderFns } from "./noCompany.vue?vue&type=template&id=f594c0fc&scoped=true"
import script from "./noCompany.vue?vue&type=script&lang=js"
export * from "./noCompany.vue?vue&type=script&lang=js"
import style0 from "./noCompany.vue?vue&type=style&index=0&id=f594c0fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f594c0fc",
  null
  
)

export default component.exports